import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { get } from 'lodash';
import { GenericFormFields } from '../interfaces';
import CalendarToday from '@material-ui/icons/CalendarToday';

const FormDatePicker: React.FC<GenericFormFields> = ({
  fields,
  item,
  values,
  setFieldValue,
  changeField,
  errors,
}) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePicker
        inputVariant="outlined"
        fullWidth
        disabled={item.disabled || false}
        id={item.stateKey}
        label={item.label}
        format="dd/MM/yyyy"
        value={
          fields
            ? get(fields, item.stateKey, Date.now())
            : get(values, item.stateKey, Date.now())
        }
        onChange={e => {
          if (setFieldValue) setFieldValue(item.stateKey, e || '');
          if (changeField)
            changeField({
              key: item.stateKey,
              value: e || '',
            });
        }}
        error={
          !!get(errors, item.stateKey, null) || !!get(errors, item.error, null)
        }
        helperText={
          get(errors, item.stateKey, null) || get(errors, item.error, null)
        }
        InputProps={{
          endAdornment: <CalendarToday />,
        }}
        disableFuture={item.disabledFuture}
        disablePast={item.disabledPast}
        minDate={item.minDate}
        maxDate={item.maxDate}
      />
    </MuiPickersUtilsProvider>
  );
};

export default FormDatePicker;
